import type { QuizAnswers } from "@/features/quiz/types"
import { parseBirthPlace } from "@/features/quiz/lib/birthplace"

import type { AuraScanPublicUser } from "../types"

const GENDERS: AuraScanPublicUser["gender"][] = ["male", "female", "other"]

function asString(value: QuizAnswers[string] | undefined): string | null {
  return typeof value === "string" && value.trim() !== "" ? value.trim() : null
}

function inEnum<T extends string>(value: string | null, allowed: readonly T[]): T | null {
  return value && (allowed as readonly string[]).includes(value) ? (value as T) : null
}

/** Convert the quiz time ("9:00 AM" / "12:30 PM" / "unknown") to 24h "HH:mm" or null. */
function normalizeBirthTime(value: string | null): string | null {
  if (!value || value === "unknown") return null
  const match = value.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i)
  if (!match) return null
  let hour = Number(match[1]) % 12
  const minute = match[2]
  if (match[3].toUpperCase() === "PM") hour += 12
  return `${String(hour).padStart(2, "0")}:${minute}`
}

/**
 * Public Aura Scan snapshot from quiz answers. Required: `gender` + `dob`.
 * Birth time / place are optional (other funnels often omit them).
 */
export function buildAuraScanInput(answers: QuizAnswers): AuraScanPublicUser | null {
  const gender = inEnum(asString(answers.gender), GENDERS)
  const birthDate = asString(answers.dob)
  if (!gender || !birthDate) return null

  return {
    name: asString(answers.name),
    gender,
    birthDate,
    birthTime: normalizeBirthTime(asString(answers.tob)),
    birthPlace: parseBirthPlace(asString(answers.birthplace)),
  }
}
